"use client";

import { useSession } from "@/contexts/session";
import { useFeatureFlag } from "@/components/utilities/featureFlag";
import { ActiveInvestingEntityPermissionsDocument } from "./WithMutationPermission.generated";
import { useQuery } from "@apollo/client/react";

export function PermissionsPrefetch() {
	const { hasAuthenticatedSession } = useSession();
	const isPermissionEnabled = useFeatureFlag("INVESTOR_PORTAL_PERMISSIONING");

	useQuery(ActiveInvestingEntityPermissionsDocument, {
		skip: !hasAuthenticatedSession || !isPermissionEnabled,
	});

	return null;
}
